import { render, staticRenderFns } from "./Vote.vue?vue&type=template&id=fc48f6ec&scoped=true"
import script from "./Vote.vue?vue&type=script&lang=js"
export * from "./Vote.vue?vue&type=script&lang=js"
import style0 from "./Vote.vue?vue&type=style&index=0&id=fc48f6ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc48f6ec",
  null
  
)

export default component.exports